import React, { useState, useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';
import api from '../../../services/api';

const QuickProductsTab = () => {
  const [quickProducts, setQuickProducts] = useState([]);
  const [quickProductsLoading, setQuickProductsLoading] = useState(false);
  const [showQuickProductModal, setShowQuickProductModal] = useState(false);
  const [editingQuickProduct, setEditingQuickProduct] = useState(null);
  const [newQuickProduct, setNewQuickProduct] = useState({ nazwa: '', icon: 'fas fa-shopping-bag', product_id: '', aktywny: true });
  const [productSearchForQuick, setProductSearchForQuick] = useState('');
  const [productSearchResults, setProductSearchResults] = useState([]);

  const loadQuickProducts = useCallback(async () => {
    setQuickProductsLoading(true);
    try {
      const { data } = await api.get('/pos/quick-products/all');
      if (data.success) {
        setQuickProducts(data.data || []);
      }
    } catch (err) {
      console.error('Błąd ładowania szybkich produktów:', err);
    } finally {
      setQuickProductsLoading(false);
    }
  }, []);

  const searchProductsForQuick = async (query) => {
    if (!query || query.length < 2) {
      setProductSearchResults([]);
      return;
    }
    try {
      const { data } = await api.get('/products', { params: { search: query, limit: 10 } });
      if (data.success) {
        setProductSearchResults(data.data || []);
      }
    } catch (err) {
      console.error('Błąd wyszukiwania produktów:', err);
    }
  };

  const addQuickProduct = async () => {
    if (!newQuickProduct.nazwa.trim()) {
      toast.error('Nazwa przycisku jest wymagana');
      return;
    }
    if (!newQuickProduct.product_id) {
      toast.error('Wybierz produkt');
      return;
    }
    try {
      const { data } = await api.post('/pos/quick-products', newQuickProduct);
      if (data.success) {
        setNewQuickProduct({ nazwa: '', icon: 'fas fa-shopping-bag', product_id: '', aktywny: true });
        setProductSearchForQuick('');
        setProductSearchResults([]);
        setShowQuickProductModal(false);
        loadQuickProducts();
        toast.success('Szybki produkt dodany pomyślnie');
      } else {
        toast.error(data.message || 'Błąd dodawania');
      }
    } catch (err) {
      console.error('Błąd dodawania szybkiego produktu:', err);
      toast.error('Błąd dodawania szybkiego produktu');
    }
  };

  const updateQuickProduct = async () => {
    if (!editingQuickProduct) return;
    try {
      const { data } = await api.put(`/pos/quick-products/${editingQuickProduct.id}`, editingQuickProduct);
      if (data.success) {
        setEditingQuickProduct(null);
        setShowQuickProductModal(false);
        loadQuickProducts();
        toast.success('Szybki produkt zaktualizowany');
      } else {
        toast.error(data.message || 'Błąd aktualizacji');
      }
    } catch (err) {
      console.error('Błąd aktualizacji szybkiego produktu:', err);
      toast.error('Błąd aktualizacji szybkiego produktu');
    }
  };

  const deleteQuickProduct = async (id) => {
    if (!window.confirm('Czy na pewno chcesz usunąć ten przycisk szybkiego produktu?')) return;
    try {
      const { data } = await api.delete(`/pos/quick-products/${id}`);
      if (data.success) {
        loadQuickProducts();
        toast.success('Szybki produkt usunięty');
      } else {
        toast.error(data.message || 'Błąd usuwania');
      }
    } catch (err) {
      console.error('Błąd usuwania szybkiego produktu:', err);
      toast.error('Błąd usuwania szybkiego produktu');
    }
  };

  const toggleQuickProductActive = async (qp) => {
    try {
      const { data } = await api.put(`/pos/quick-products/${qp.id}`, { aktywny: !qp.aktywny });
      if (data.success) {
        loadQuickProducts();
      }
    } catch (err) {
      console.error('Błąd zmiany statusu:', err);
    }
  };

  useEffect(() => {
    loadQuickProducts();
  }, [loadQuickProducts]);

  return (
    <div className="admin-table-wrap">
      <style>{`
        @media (max-width: 600px) {
          .qp-header { flex-direction: column !important; align-items: stretch !important; gap: 0.5rem !important; }
          .qp-list-row { flex-wrap: wrap !important; gap: 0.5rem !important; }
          .qp-list-row .qp-info { flex: 1 1 100% !important; }
          .qp-list-row .qp-actions { flex: 1 1 100% !important; justify-content: flex-end !important; }
          .qp-modal { width: 95vw !important; max-width: 95vw !important; }
          .qp-price-col { display: none !important; }
        }
        @media (min-width: 601px) and (max-width: 900px) {
          .qp-modal { width: 90vw !important; max-width: 600px !important; }
        }
      `}</style>
      <div style={{
        backgroundColor: 'var(--card-bg)',
        border: '1px solid var(--border)',
        borderRadius: '0.5rem',
        boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)'
      }}>
        {/* Header */}
        <div className="qp-header" style={{
          padding: '1rem 1.5rem',
          borderBottom: '1px solid var(--border)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <h4 style={{ margin: 0, fontWeight: '600' }}>
              <span style={{ marginRight: '0.5rem' }}>&#x1F6D2;</span>
              Szybkie Produkty POS
            </h4>
            <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: 'var(--text-muted)' }}>
              Konfiguracja przycisk&oacute;w szybkiego dodawania produkt&oacute;w w koszyku POS
            </p>
          </div>
          <button
            onClick={() => {
              setEditingQuickProduct(null);
              setNewQuickProduct({ nazwa: '', icon: 'fas fa-shopping-bag', product_id: '', aktywny: true });
              setProductSearchForQuick('');
              setProductSearchResults([]);
              setShowQuickProductModal(true);
            }}
            style={{
              padding: '6px 12px',
              fontSize: '12px',
              border: '1px solid var(--success)',
              color: 'var(--success)',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <i className="fas fa-plus"></i>
            Dodaj Przycisk
          </button>
        </div>

        {/* Info */}
        <div style={{
          padding: '1rem 1.5rem',
          backgroundColor: 'var(--info-light)',
          borderBottom: '1px solid var(--info-light)'
        }}>
          <i className="fas fa-info-circle" style={{ color: 'var(--info)', marginRight: '0.5rem' }}></i>
          <span style={{ fontSize: '0.85rem', color: 'var(--info)' }}>
            Przyciski pojawi&#x0105; si&#x0119; w koszyku POS obok opcji "Dost&#x0119;pne" i pozwol&#x0105; na szybkie dodawanie cz&#x0119;sto u&#x017C;ywanych produkt&oacute;w (np. torby).
          </span>
        </div>

        {/* Lista */}
        <div style={{ padding: '1rem 1.5rem' }}>
          {quickProductsLoading ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <i className="fas fa-spinner fa-spin fa-2x" style={{ color: 'var(--text-muted)' }}></i>
              <p style={{ marginTop: '0.5rem', color: 'var(--text-muted)' }}>&#x141;adowanie...</p>
            </div>
          ) : quickProducts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '3rem', color: 'var(--text-muted)' }}>
              <i className="fas fa-shopping-bag fa-3x" style={{ marginBottom: '1rem', opacity: 0.5 }}></i>
              <p style={{ margin: 0 }}>Brak skonfigurowanych szybkich produkt&oacute;w</p>
              <p style={{ fontSize: '0.85rem' }}>Kliknij "Dodaj Przycisk" aby doda&#x0107; pierwszy</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {quickProducts.map((qp, index) => (
                <div
                  key={qp.id}
                  className="qp-list-row"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0.75rem 1rem',
                    backgroundColor: qp.aktywny ? 'var(--bg)' : 'var(--warning-light)',
                    border: '1px solid var(--border)',
                    borderRadius: '0.375rem',
                    gap: '1rem'
                  }}
                >
                  <span style={{ color: 'var(--text-muted)', fontWeight: '500', minWidth: '30px' }}>
                    #{index + 1}
                  </span>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: 'var(--purple)',
                    borderRadius: '0.375rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white'
                  }}>
                    <i className={qp.icon || 'fas fa-shopping-bag'}></i>
                  </div>
                  <div className="qp-info" style={{ flex: 1 }}>
                    <div style={{ fontWeight: '600' }}>{qp.nazwa}</div>
                    <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                      Produkt: {qp.product_name || `ID: ${qp.product_id}`}
                      {(qp.price != null && qp.price !== '') && <span className="qp-price-col"> {`• ${Number(qp.price).toFixed(2)} zł`}</span>}
                    </div>
                  </div>
                  <div className="qp-actions" style={{ display: 'flex', gap: '0.5rem' }}>
                    <button
                      onClick={() => toggleQuickProductActive(qp)}
                      title={qp.aktywny ? 'Dezaktywuj' : 'Aktywuj'}
                      style={{
                        padding: '4px 10px',
                        fontSize: '11px',
                        border: '1px solid',
                        borderColor: qp.aktywny ? 'var(--success)' : 'var(--warning)',
                        backgroundColor: qp.aktywny ? 'var(--success-light)' : 'var(--warning-light)',
                        color: qp.aktywny ? 'var(--success)' : 'var(--warning)'
                      }}
                    >
                      <i className={qp.aktywny ? 'fas fa-check' : 'fas fa-pause'}></i>
                    </button>
                    <button
                      onClick={() => {
                        setEditingQuickProduct(qp);
                        setProductSearchForQuick(qp.product_name || '');
                        setShowQuickProductModal(true);
                      }}
                      style={{
                        padding: '4px 10px',
                        fontSize: '11px',
                        border: '1px solid var(--info)',
                        backgroundColor: 'var(--info-light)',
                        color: 'var(--info)'
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      onClick={() => deleteQuickProduct(qp.id)}
                      style={{
                        padding: '4px 10px',
                        fontSize: '11px',
                        border: '1px solid var(--danger)',
                        backgroundColor: 'var(--danger-light)',
                        color: 'var(--danger)'
                      }}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Ikony */}
        <div style={{
          padding: '1rem 1.5rem',
          borderTop: '1px solid var(--border)',
          backgroundColor: 'var(--bg)'
        }}>
          <h6 style={{ margin: '0 0 0.5rem', fontWeight: '600' }}>Dost&#x0119;pne ikony:</h6>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            {[
              { icon: 'fas fa-shopping-bag', label: 'Torba' },
              { icon: 'fas fa-box', label: 'Pudełko' },
              { icon: 'fas fa-gift', label: 'Prezent' },
              { icon: 'fas fa-tag', label: 'Tag' },
              { icon: 'fas fa-star', label: 'Gwiazdka' },
              { icon: 'fas fa-heart', label: 'Serce' },
              { icon: 'fas fa-coffee', label: 'Kawa' },
              { icon: 'fas fa-utensils', label: 'Sztućce' },
              { icon: 'fas fa-leaf', label: 'Liść' },
              { icon: 'fas fa-bolt', label: 'Błyskawica' }
            ].map(item => (
              <div
                key={item.icon}
                style={{
                  padding: '0.35rem 0.6rem',
                  backgroundColor: 'var(--card-bg)',
                  border: '1px solid var(--border)',
                  borderRadius: '0.25rem',
                  fontSize: '0.8rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.4rem'
                }}
              >
                <i className={item.icon}></i>
                <span>{item.label}</span>
                <code style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>{item.icon}</code>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal dodawania/edycji */}
      {showQuickProductModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div className="qp-modal" style={{
            backgroundColor: 'var(--card-bg)',
            borderRadius: '0.5rem',
            width: '500px',
            maxWidth: '500px',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.15)'
          }}>
            <div style={{
              padding: '1rem 1.5rem',
              borderBottom: '1px solid var(--border)',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h5 style={{ margin: 0, fontWeight: '600' }}>
                {editingQuickProduct ? 'Edytuj Szybki Produkt' : 'Dodaj Szybki Produkt'}
              </h5>
              <button
                onClick={() => {
                  setShowQuickProductModal(false);
                  setEditingQuickProduct(null);
                }}
                style={{
                  background: 'none',
                  
                  fontSize: '1.5rem',
                  color: 'var(--text-muted)'
                }}
              >
                &times;
              </button>
            </div>

            <div style={{ padding: '1.5rem' }}>
              {/* Nazwa przycisku */}
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                  Nazwa przycisku *
                </label>
                <input
                  type="text"
                  placeholder="np. Torba mała, Torba duża"
                  value={editingQuickProduct ? editingQuickProduct.nazwa : newQuickProduct.nazwa}
                  onChange={(e) => {
                    if (editingQuickProduct) {
                      setEditingQuickProduct({ ...editingQuickProduct, nazwa: e.target.value });
                    } else {
                      setNewQuickProduct({ ...newQuickProduct, nazwa: e.target.value });
                    }
                  }}
                  style={{
                    width: '100%',
                    padding: '0.5rem 0.75rem',
                    border: '1px solid var(--border)',
                    borderRadius: '0.375rem',
                    fontSize: '0.9rem'
                  }}
                />
              </div>

              {/* Ikona */}
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                  Ikona (klasa FontAwesome)
                </label>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: 'var(--purple)',
                    borderRadius: '0.375rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white'
                  }}>
                    <i className={(editingQuickProduct ? editingQuickProduct.icon : newQuickProduct.icon) || 'fas fa-shopping-bag'}></i>
                  </div>
                  <input
                    type="text"
                    placeholder="fas fa-shopping-bag"
                    value={editingQuickProduct ? editingQuickProduct.icon : newQuickProduct.icon}
                    onChange={(e) => {
                      if (editingQuickProduct) {
                        setEditingQuickProduct({ ...editingQuickProduct, icon: e.target.value });
                      } else {
                        setNewQuickProduct({ ...newQuickProduct, icon: e.target.value });
                      }
                    }}
                    style={{
                      flex: 1,
                      padding: '0.5rem 0.75rem',
                      border: '1px solid var(--border)',
                      borderRadius: '0.375rem',
                      fontSize: '0.9rem'
                    }}
                  />
                </div>
                <small style={{ color: 'var(--text-muted)' }}>
                  Szybki wyb&oacute;r:
                  {['fas fa-shopping-bag', 'fas fa-box', 'fas fa-gift', 'fas fa-tag', 'fas fa-star'].map(icon => (
                    <button
                      key={icon}
                      type="button"
                      onClick={() => {
                        if (editingQuickProduct) {
                          setEditingQuickProduct({ ...editingQuickProduct, icon: icon });
                        } else {
                          setNewQuickProduct({ ...newQuickProduct, icon: icon });
                        }
                      }}
                      style={{
                        background: 'none',
                        
                        padding: '0.25rem 0.5rem',
                        margin: '0 0.1rem'
                      }}
                    >
                      <i className={icon}></i>
                    </button>
                  ))}
                </small>
              </div>

              {/* Wyszukiwanie produktu */}
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                  Produkt *
                </label>
                <input
                  type="text"
                  placeholder="Wyszukaj produkt po nazwie lub kodzie..."
                  value={productSearchForQuick}
                  onChange={(e) => {
                    setProductSearchForQuick(e.target.value);
                    searchProductsForQuick(e.target.value);
                  }}
                  style={{
                    width: '100%',
                    padding: '0.5rem 0.75rem',
                    border: '1px solid var(--border)',
                    borderRadius: '0.375rem',
                    fontSize: '0.9rem'
                  }}
                />

                {/* Wybrany produkt */}
                {(editingQuickProduct?.product_id || newQuickProduct.product_id) && (
                  <div style={{
                    marginTop: '0.5rem',
                    padding: '0.5rem 0.75rem',
                    backgroundColor: 'var(--success-light)',
                    border: '1px solid var(--success-light)',
                    borderRadius: '0.375rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <span>
                      <i className="fas fa-check-circle" style={{ color: 'var(--success)', marginRight: '0.5rem' }}></i>
                      Wybrany: {editingQuickProduct?.product_name || newQuickProduct.product_name || `ID: ${editingQuickProduct?.product_id || newQuickProduct.product_id}`}
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        if (editingQuickProduct) {
                          setEditingQuickProduct({ ...editingQuickProduct, product_id: '', product_name: '' });
                        } else {
                          setNewQuickProduct({ ...newQuickProduct, product_id: '', product_name: '' });
                        }
                        setProductSearchForQuick('');
                      }}
                      style={{
                        background: 'none',
                        
                        color: 'var(--danger)'
                      }}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                )}

                {/* Wyniki wyszukiwania */}
                {productSearchResults.length > 0 && (
                  <div style={{
                    marginTop: '0.5rem',
                    border: '1px solid var(--border)',
                    borderRadius: '0.375rem',
                    maxHeight: '200px',
                    overflowY: 'auto'
                  }}>
                    {productSearchResults.map(product => (
                      <div
                        key={product.id}
                        onClick={() => {
                          const productName = product.name || product.nazwa;
                          if (editingQuickProduct) {
                            setEditingQuickProduct({
                              ...editingQuickProduct,
                              product_id: product.id,
                              product_name: productName
                            });
                          } else {
                            setNewQuickProduct({
                              ...newQuickProduct,
                              product_id: product.id,
                              product_name: productName
                            });
                          }
                          setProductSearchForQuick(productName);
                          setProductSearchResults([]);
                        }}
                        style={{
                          padding: '0.5rem 0.75rem',
                          borderBottom: '1px solid var(--border)',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                      >
                        <span>{product.name || product.nazwa}</span>
                        <span style={{ color: 'var(--text-muted)' }}>
                          {(product.cena_sprzedazy_brutto || product.price || product.cena || 0).toFixed(2)} zł
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Aktywny */}
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={editingQuickProduct ? editingQuickProduct.aktywny : newQuickProduct.aktywny}
                    onChange={(e) => {
                      if (editingQuickProduct) {
                        setEditingQuickProduct({ ...editingQuickProduct, aktywny: e.target.checked });
                      } else {
                        setNewQuickProduct({ ...newQuickProduct, aktywny: e.target.checked });
                      }
                    }}
                  />
                  <span>Aktywny (widoczny w POS)</span>
                </label>
              </div>
            </div>

            <div style={{
              padding: '1rem 1.5rem',
              borderTop: '1px solid var(--border)',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '0.5rem'
            }}>
              <button
                onClick={() => {
                  setShowQuickProductModal(false);
                  setEditingQuickProduct(null);
                }}
                style={{
                  padding: '6px 12px',
                  fontSize: '12px',
                  border: '1px solid var(--text-muted)',
                  backgroundColor: 'var(--card-bg)',
                  color: 'var(--text-muted)'
                }}
              >
                Anuluj
              </button>
              <button
                onClick={editingQuickProduct ? updateQuickProduct : addQuickProduct}
                style={{
                  padding: '6px 12px',
                  fontSize: '12px',
                  border: '1px solid var(--success)',
                  color: 'var(--success)',
                  fontWeight: '500'
                }}
              >
                {editingQuickProduct ? 'Zapisz Zmiany' : 'Dodaj'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickProductsTab;
